import React, { useState } from "react";
import { Form, Input, Button, Row, Col, Modal, Typography, message } from "antd";
import { ExclamationCircleOutlined, DeleteOutlined, PlusCircleOutlined, LeftOutlined, RightOutlined} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";

const { confirm } = Modal;
const { Title, Text } = Typography;

const PartnershipInterests = () => {
    const [form] = Form.useForm();
    const [interests, setInterests] = useState([{name: "",valuation: "",ownership: "",contributions: "",distributions: "",liabilities: ""}]);

    const history = useHistory();

    const addInterest = () => {
        setInterests([...interests,{name: "",valuation: "",ownership: "",contributions: "",distributions: "",liabilities: ""}]);
    };

    const deleteInterest = (index) => {
        confirm({
            title: "Are you sure you want to delete this partnership interest?",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            onOk() {
                setInterests(interests.filter((_, idx) => idx !== index));
            },
        });
    };

    const onBack = () => {
        history.push(routes.businessAssets.path); 
    };

    const onNext = () => {
       history.push(routes.personalHolding.path); 
    };

    const onFinish = (values) => {
        message.success("Partnership Interests Saved!");
        console.log("Saved values:", values);
        onNext();
    };

    return (
        <LeftLayout>
            <Row style={{ minHeight: "100vh", background: "#fff" }} align="top" className="rightbox">
                <Col span={24}>
                    <Title level={3} style={{ marginBottom: 40 }}>
                        Partnership Interests 
                    </Title>

                    <Form form={form} layout="vertical" onFinish={onFinish}>
                        {interests.map((interest, idx) => (
                            <div key={idx}>
                                <Row justify="space-between" align="middle"> 
                                    <Col>
                                        <Text strong style={{ fontSize: 16 }}>
                                            Partnership {String(idx + 1).padStart(2, "0")}
                                        </Text>
                                    </Col>
                                    <Col>
                                        {idx > 0 && (
                                            <Button
                                                type="text"
                                                icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                onClick={() => deleteInterest(idx)}
                                            />
                                        )}
                                    </Col>
                                </Row>

                                <Form.Item
                                    label="Name Of Partnership/Fund"
                                    name={["interests", idx, "name"]}
                                    rules={[{ required: true, message: "Name Of Partnership/Fund is required" }]}
                                    className='w50'
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="Valuation Of Interest"
                                    name={["interests", idx, "valuation"]}
                                    rules={[{ required: true, message: "Valuation Of Interest is required" }]}
                                    className='w50'
                                >
                                    <Input placeholder="$" />
                                </Form.Item>

                                <Form.Item
                                    label="Ownership Percentage"
                                    name={["interests", idx, "ownership"]}
                                    rules={[{ required: true, message: "Ownership Percentage is required" }]}
                                    className='w50'
                                >
                                    <Input placeholder="%" />
                                </Form.Item>

                                <Form.Item
                                    label="Capital Contributions Made"
                                    name={["interests", idx, "contributions"]}
                                    rules={[{ required: true, message: "Capital Contributions Made is required" }]}
                                    className='w50'
                                >
                                    <Input placeholder="$" />
                                </Form.Item>

                                <Form.Item
                                    label="Distributions Received (If Any)"
                                    name={["interests", idx, "distributions"]}
                                    rules={[{ required: true, message: "Distributions Received is required" }]}
                                    className='w50'
                                >
                                    <Input placeholder="$" />
                                </Form.Item>

                                <Form.Item
                                    label="Outstanding Liabilities (If Any)"
                                    name={["interests", idx, "liabilities"]}
                                    rules={[{ required: true, message: "Outstanding Liabilities is required" }]}
                                    className='w50'
                                >
                                    <Input placeholder="$" />
                                </Form.Item>
                            </div>
                        ))}

                        <Form.Item>
                            <Button
                                type="link"
                                icon={<PlusCircleOutlined />}
                                onClick={addInterest}
                                style={{
                                    padding: 0,
                                    fontWeight: "bold",
                                    fontSize: 15,
                                    marginTop: 10,
                                }}
                                className='w50'
                            >
                                Add Another Partnership Interest
                            </Button>
                        </Form.Item>

                        <Form.Item>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                                <Button
                                    onClick={onBack}
                                    icon={<LeftOutlined />}
                                    className='w50'
                                >
                                    Go Back
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className='w50'
                                >
                                    Save And Proceed <RightOutlined />
                                </Button>
                                <Button
                                    type="default"
                                    onClick={onNext}
                                    className='w50'
                                >
                                    Next <RightOutlined />
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </LeftLayout>
    );
};

export default PartnershipInterests;
